<template>
  <div class="app-main-content voucher-maintenance">
    <div class="tabs-container">
      <div class="grid-view">
        <div class="main-content voucher-list">
          <search-item
            config-module="2000"
            :reset="true"
            :custom-sim-query-placeholder="$t('Message.QuickSearchChineseName')"
            @click-more="value=>isAdvancedQuery=value"
            @simSearchItemCallBack="toSimpleQuery"
            @advSearchItemCallBack="toAdvancedQuery"
          >
            <div slot="operations" class="triggers">
              <el-button type="danger" @click="removeHandler">{{ $t('CargoMsg.Cargo_Delete') }}</el-button>
              <!--一键添加平台认证合作伙伴          -->
              <el-button v-show="false" type="primary" @click="createWTCompanyHandler">{{ $t('Partners.credit_wtCreateCompany') }}</el-button>
              <img v-show="false" src="/static/info.png" style="width: 20px;height: 18px; margin: 0 auto;" title="添加平台认证合作伙伴，与“沃行之家”交互，共建物流生态圈。">
            </div>
          </search-item>
          <div class="section grid-wrapper">
            <cargo-ag-grid
              :grid-params.sync="gridParams"
              :grid-options="gridOptions"
              :column-defs="columnDefs"
              :row-data="rowData"
              @gridReady="onReady"
            />
          </div>
          <div class="pagination-wrapper">
            <cargo-pagination
              :page-count="filter.pageCount"
              config-module="20211215"
              :page.sync="filter.pageNum"
              :limit.sync="filter.pageSize"
              :total="filter.total"
              @pagination="toQueryByPage()"
            />
          </div>
        </div>
      </div>
    </div>
    <w-t-application-list-window :visible="openSendList.visible" @visibleHandler="visibleHandler" />
  </div>
</template>

<script>

import AccountSetPopup from '@/views/cargo/v0/FinanceManage/FinanceInterface/components/AccountSetPopup'
import cargoUserSelect from '@/components/Cargo/Common/cargoUserSelect'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { getLoading } from '@/utils/utilBaseElement'
import CommonState from '@/class/cargo/model/parameters/CommonState'
import { deleteApplyFunc, wtQueryApplyLitFunc } from '@/api/company'
import ColumnUtils from '@/utils/ColumnUtils'
import searchItem from '@/components/Cargo/Common/cargoCombinationSearch'
import WTApplicationListWindow from '@/views/cargo/v0/Information/components/partner/WTApplicationListWindow'
import { cache, cacheName } from '@/utils/cacheManager'

export default {
  name: 'WtApplyList',
  components: { AccountSetPopup, cargoUserSelect, cargoAdvanceSelect, searchItem, WTApplicationListWindow },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      selectedDataList: [],
      loading: null,
      gridApi: null,
      wtCreateCompany: this.$checkPermission(['button_applyList_wtCreateCompany']),
      gridParams: {},
      isAdvancedQuery: true,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          resizable: true,
          filter: true
        },
        pagination: false,
        onRowSelected: this.onRowSelected
      },
      openSendList: { // 一键添加平台认证合作伙伴
        visible: false
      },
      filterJson: {
        companyName: '',
        page: 1,
        branchId: 0, // 分公司ID
        conditions: [], // 查询条件
        snapshotConditions: [] // 高级查询条件（点击查询时的快照状态）
      },
      filter: {
        total: 0,
        pageNum: 1,
        pageCount: 0,
        pageSize: 20
      },
      columnDefs: [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('CargoMsg.Cargo_number'), field: 'applyNo', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_abbreviation'), field: 'shortName', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_BranchCMP'), field: 'pushBranchCode', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_ChineseNamed'), field: 'chineseName', width: 120 },
        { headerName: this.$t('CargoMsg.Cargo_EnglishNamed'), field: 'englishName', width: 120 },
        {
          headerName: this.$t('CargoMsg.Cargo_Applicant'), field: 'createdBy', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_DateOfApplication'), field: 'dateCreated', width: 120,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('CargoMsg.Cargo_Auditor'), field: 'examineUser', width: 120 },
        {
          headerName: this.$t('CargoMsg.Cargo_AuditDate'), field: 'examineDate', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_auditResult'), field: 'ifExamine', width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        }
      ],
      rowData: [],
      voucherPeriodList: [],
      type: [
        new CommonState(0, '全部', 'ALL'),
        new CommonState(1, '客户', 'customer')
      ],
      examineType: [
        new CommonState(-1, '全部', 'ALL'),
        new CommonState(1, '是', 'YES'),
        new CommonState(0, '否', 'NO')
      ]
    }
  },
  created() {
    cache.load(cacheName.CONFIG)
  },
  mounted() {

  },
  methods: {
    onReady(params) {
      this.gridApi = params.api
    },
    // 分页查询
    toQueryByPage() {
      if (this.isAdvancedQuery) {
        this.toAdvancedQuery()
      } else {
        this.toSimpleQuery(this.filterJson.companyName)
      }
    },
    toSimpleQuery(keyword) {
      this.filter.pageNum = 1
      this.filterJson.companyName = keyword.trim()
      this.filterJson.conditions = []
      this.queryPageHandler()
    },
    toAdvancedQuery(data) {
      // 高级查询条件组装
      if (typeof data !== 'undefined') {
        this.filter.pageNum = 1
        this.filterJson.companyName = ''
      }
      this.queryPageHandler(data)
    },
    queryPageHandler(data) {
      this.loading = getLoading()
      if (typeof data !== 'undefined') {
        this.filterJson.conditions = data
      }
      this.filterJson.branchId = this.$store.getters.currentOfficeId
      this.filterJson.pageNum = this.filter.pageNum
      this.filterJson.pageSize = this.filter.pageSize
      wtQueryApplyLitFunc(this.filterJson).then(res => this.handleQueryData(res)).catch((err) => {
        this.$message.error(err)
      }).finally(() => {
        this.loading.close()
      })
    },
    // 查询返回结果[公用]
    handleQueryData(res) {
      this.rowData = res.data.list
      this.filter.pageNum = res.data.pageNum
      this.filter.pageSize = res.data.pageSize
      this.filter.total = Number(res.data.total)
      this.filter.pageCount = res.data.pages
      this.selectedDataList = []
      this.gridApi.clearFocusedCell()
    },
    removeHandler() {
      if (!this.selectedDataList || this.selectedDataList.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectData'))
        return
      }
      this.$confirm('确定要删除吗?', this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        const list = []
        for (const c of this.selectedDataList) {
          list.push(c.uuid)
        }
        deleteApplyFunc(list).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          for (const i of list) {
            const index = this.rowData.findIndex(p => p.uuid === i)
            if (index > -1) {
              this.rowData.splice(index, 1)
            }
          }
          this.selectedDataList = []
        }).catch((err) => {
          this.$message.error(err)
        }).finally(() => {
          this.loading.close()
        })
      }).catch(() => {
      })
    },
    // 行首多选框勾选事件
    onRowSelected(event) {
      if (!event || !event.data) return
      if (event.node.isSelected()) {
        this.selectedDataList.push(event.data)
      } else {
        this.selectedDataList = this.gridApi.getSelectedRows()
      }
    },
    // 一键添加平台认证合作伙伴
    createWTCompanyHandler() {
      this.openSendList.visible = true
    },
    visibleHandler() {
      this.openSendList.visible = false
    }
  }
}
</script>
